var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement as _createElement } from "react";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useContext, useState, useEffect } from "react";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Button from '../../button';
import { t, tReact } from '@mp/locale';
import { endsWith } from "lodash";
import Cookies from "js-cookie";
import { analytics } from "../../communication";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { OrderContext } from "../../hooks/OrderContext";
import { StepContext } from "../../hooks/StepContext";
import PropertyExtra from "./PropertyExtra";
import EstimatedPrice from "../EstimatedPrice/EstimatedPrice";
import { patchOrder, TRACKING_NAMESPACE, trackingEvents, unitSizeLabels, } from "../../services/schedulerService";
import "./property-styles.scss";
import { SchedulerDataContext } from "../../hooks/SchedulerDataContext";
import { AppPropsContext } from "../../hooks/AppPropsContext";
import SchedulerCTA from "./SchedulerCTA";
import CaptureRequirementsDetail from "../CaptureRequirements/CaptureRequierementsDetail";
export default function PropertySpace(_a) {
    var _b;
    var suiteNumber = _a.suiteNumber, propertyType = _a.propertyType, captureType = _a.captureType, inputFields = _a.inputFields, inputReset = _a.inputReset, backStep = _a.backStep, props = __rest(_a, ["suiteNumber", "propertyType", "captureType", "inputFields", "inputReset", "backStep"]);
    var orderDetails = JSON.parse(sessionStorage.getItem("order-details")) || null;
    var _c = useContext(AppPropsContext), isFreeSubscription = _c.isFreeSubscription, freeSubscriptionCallback = _c.freeSubscriptionCallback, successMessage = _c.successMessage;
    var _d = useState(''), error = _d[0], setError = _d[1];
    var _e = useState(undefined), errorData = _e[0], setErrorData = _e[1];
    var _f = useContext(OrderContext), order = _f.order, setOrder = _f.setOrder;
    var _g = useContext(SchedulerDataContext), schedulerData = _g.schedulerData, setSchedulerData = _g.setSchedulerData;
    var next = useContext(StepContext).next;
    var _h = useState(0), totalSize = _h[0], setTotalSize = _h[1];
    var _j = useState("SQUARE_FT"), unit = _j[0], setUnit = _j[1];
    var _k = useState(false), freeUserCheck = _k[0], setFreeUserCheck = _k[1];
    var _l = useState(false), disabledNext = _l[0], setDisableNext = _l[1];
    useEffect(function () {
        // Reset disble on address change since pro3 and pro2
        // addresses have different size constraints
        setError('');
        setErrorData(undefined);
        setDisableNext(false);
    }, [(_b = order === null || order === void 0 ? void 0 : order.address) === null || _b === void 0 ? void 0 : _b.place_id]);
    var COOKIE_NAME = 'capture_service_address';
    var getDefaultValues = function () {
        var cookie = Cookies.get(COOKIE_NAME);
        var spaces = [
            {
                name: null,
                property_size: null,
                property_size_unit: "SQUARE_FT",
            }
        ];
        if (orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.spaces) {
            spaces = orderDetails.spaces;
        }
        if (cookie && !orderDetails) {
            var cookieDetails = JSON.parse(cookie);
            if (cookieDetails === null || cookieDetails === void 0 ? void 0 : cookieDetails.spaces) {
                spaces = cookieDetails === null || cookieDetails === void 0 ? void 0 : cookieDetails.spaces;
            }
        }
        return {
            suite: '',
            property_type: '',
            spaces: spaces,
        };
    };
    var _m = useForm({
        mode: "onChange",
        defaultValues: getDefaultValues(),
    }), register = _m.register, reset = _m.reset, control = _m.control, handleSubmit = _m.handleSubmit, formState = _m.formState, getValues = _m.getValues, setValue = _m.setValue, watch = _m.watch;
    var convertSize = function (size, from, to) {
        if (from === "SQUARE_METER" && to === "SQUARE_FT") {
            return size * 10.7639;
        }
        if (from === "SQUARE_FT" && to === "SQUARE_METER") {
            return size / 10.7639;
        }
        return size;
    };
    var resetOnBack = function () {
        backStep();
        setDisableNext(false);
        setFreeUserCheck(false);
    };
    useEffect(function () {
        var _a, _b, _c;
        setUnit((_c = (_b = (_a = getValues()) === null || _a === void 0 ? void 0 : _a.spaces) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.property_size_unit);
        var sizeReduction = getValues().spaces.reduce(function (total, item) {
            var size = item.property_size;
            var property_size = size === '' || isNaN(size) ? 0 : size;
            if (unit === "SQUARE_METER" && item.property_size_unit === "SQUARE_FT") {
                return total + convertSize(property_size, "SQUARE_FT", "SQUARE_METER");
            }
            if (unit === "SQUARE_FT" && item.property_size_unit === "SQUARE_METER") {
                return total + convertSize(property_size, "SQUARE_METER", "SQUARE_FT");
            }
            return total + property_size;
        }, 0);
        setTotalSize(sizeReduction);
        // This will rerun evertime. Probably not a big deal, but doesn't really need an effect
    }, [getValues()]);
    var _o = useFieldArray({
        control: control,
        name: "spaces",
    }), spaces = _o.fields, append = _o.append, remove = _o.remove;
    var setValueWithValidation = function (name, value) {
        setError('');
        setErrorData(undefined);
        setDisableNext(false);
        setValue(name, value, {
            shouldValidate: true,
            shouldDirty: true,
            shouldTouch: true,
        });
    };
    // Needed so React can really update the area calculation. The ideal scenario is to just remove all the react hook forms plugin references here!
    watch('spaces');
    var _p = useState(false), coverageChecked = _p[0], setCoverageChecked = _p[1];
    var preventText = function (e) {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };
    var addSpace = function () {
        var _a;
        if (!((_a = spaces === null || spaces === void 0 ? void 0 : spaces[0]) === null || _a === void 0 ? void 0 : _a.name)) {
            setValue('spaces.0.name', order.address.address_string);
        }
        append({
            name: null,
            property_size: null,
            property_size_unit: "SQUARE_FT",
        });
        setDisableNext(false);
    };
    var handleTracking = function (event) {
        var _a;
        var _b = (event === null || event === void 0 ? void 0 : event.target) || {}, name = _b.name, value = _b.value;
        if (new RegExp(/property\_size(\_unit)?/).test(name)) {
            setCoverageChecked(false);
        }
        if (name) {
            var eventName = "PROPERTY_DETAILS_".concat(endsWith(name, "property_size")
                ? "TOTAL_PROPERTY_SIZE"
                : name.toUpperCase(), "_ENTERED");
            if (trackingEvents[eventName]) {
                analytics.track(TRACKING_NAMESPACE, trackingEvents[eventName], (_a = {},
                    _a[name] = value,
                    _a));
            }
        }
    };
    var onSubmit = function (data, e) {
        var _a, _b;
        e.preventDefault();
        setDisableNext(true);
        var payload = __assign(__assign({}, order), getValues());
        if (inputFields === null || inputFields === void 0 ? void 0 : inputFields.capture_requirements_questions) {
            payload.capture_requirements_questions = inputFields.capture_requirements_questions;
        }
        payload.property_type = propertyType.toUpperCase();
        payload.property_size_unit = unit;
        payload.suite = suiteNumber;
        setSchedulerData({
            step: "property_details",
            data: __assign(__assign({}, payload), { order: payload, capture_type: (_b = (_a = inputFields === null || inputFields === void 0 ? void 0 : inputFields.capture_requirements_questions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.answer_choices[0] }),
        });
        // Tech Debt
        // There's a lot of duplication of data when being passed around.
        // For now, save everything even if duplicates.
        // If refactoring, use a single source of truth (preferably the order)
        // And update session storage with that data only.
        // Creating a data object which preserves all the user added inputs
        var allData = __assign(__assign({}, order), inputFields);
        allData.spaces = getValues().spaces;
        patchOrder(payload, "property-details")
            .then(function (data) {
            setOrder(data);
            sessionStorage.setItem("order-details", JSON.stringify((__assign(__assign({}, data), allData))));
            /*
             * Remove cookie. The session storage is now source of truth.
             * TECH DEBT: if session storage is being used as state managment,
             * we should set the session on project init instead of mixing
             * and matching with cookies.
             */
            Cookies.remove(COOKIE_NAME, {
                path: '/',
                domain: ".matterport.com"
            });
            if (isFreeSubscription) {
                setFreeUserCheck(true);
                setDisableNext(true);
                return freeSubscriptionCallback(payload);
            }
            else {
                setDisableNext(false);
            }
            next();
        })
            .catch(function (res) {
            var _a, _b, _c, _d;
            // If there is a generic error not covered in translations use the message from server
            setError(((_b = (_a = res === null || res === void 0 ? void 0 : res.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || 'Error');
            if ((_d = (_c = res === null || res === void 0 ? void 0 : res.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.extra) {
                var _e = res.response.data.extra, limit = _e.limit, unit_1 = _e.unit;
                var errorUnit = unit_1 === 'ft2' ? unitSizeLabels.SQUARE_FT : unitSizeLabels.SQUARE_METER;
                setErrorData({ limit: Number(limit).toLocaleString(), errorUnit: errorUnit });
            }
            setDisableNext(false);
        });
    };
    var removeSpace = function (id) {
        remove(id);
        setError('');
        setErrorData(undefined);
        setDisableNext(false);
    };
    return (_jsxs("div", { children: [_jsxs("p", __assign({ "data-qa": "spaces-title", className: "mp-capturesvc-step-subtitle" }, { children: [" ", t("CAPTURE_SERVICES.ORDER.SPACES.spaceQuestion"), " "] })), _jsx(CaptureRequirementsDetail, { captureType: captureType, propertyType: propertyType }), _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [spaces.map(function (space, index) { return (_jsxs("div", __assign({ className: "multiSpaceSpacer" }, { children: [index > 0 &&
                                _jsx("div", __assign({ "data-qa": "remove-space", className: "multiTitle" }, { children: _jsxs("p", __assign({ onClick: function () { return removeSpace(index); } }, { children: [" X ", t("CAPTURE_SERVICES.ORDER.SPACES.LIST.ACTIONS.remove"), " "] })) })), (index !== 0 || (space === null || space === void 0 ? void 0 : space.name)) &&
                                _jsx("div", __assign({ className: "mp-form-row" }, { children: _jsx(TextField, __assign({ variant: "standard", className: "mp-form-row-input scheduler-inputs scheduler-space-inputs ", "data-qa": "space-name", id: "spaces-name-".concat(index), name: "spaces[".concat(index, "].name"), label: t("CAPTURE_SERVICES.ORDER.SPACES.spaceName") }, register("spaces.".concat(index, ".name"), {
                                        required: {
                                            value: true,
                                            message: t("CAPTURE_SERVICES.ORDER.SPACES.ERRORS.requiredSpaceName"),
                                        },
                                        onBlur: handleTracking,
                                    }))) })), _jsxs("div", __assign({ className: "mp-form-row" }, { children: [_jsx(TextField, __assign({ variant: "standard", className: "mp-form-input scheduler-inputs scheduler-space-inputs mp-capturesvc-size", id: "space-size-".concat(index), type: "text", "data-qa": "space-size", inputMode: "numeric", name: "spaces[".concat(index, "].property_size"), label: t("CAPTURE_SERVICES.ORDER.SPACES.spaceSize") }, register("spaces.".concat(index, ".property_size"), {
                                        valueAsNumber: true,
                                        required: true,
                                        min: 1,
                                        onBlur: handleTracking,
                                    }), { inputProps: { min: 1, pattern: "[0-9]*" }, onKeyPress: preventText, onChange: function (data) {
                                            setValueWithValidation("spaces.".concat(index, ".property_size"), data.target.value);
                                        }, error: !!error })), _jsx(Controller, { control: control, name: "spaces.".concat(index, ".property_size_unit"), render: function (_a) {
                                            var _b = _a.field, onChange = _b.onChange, value = _b.value;
                                            return (_jsx(Autocomplete, { className: "mp-form-input mp-capturesvc-size-unit", id: "space-size-unit-".concat(index), options: Object.keys(unitSizeLabels), disableClearable: true, getOptionLabel: function (option) { return unitSizeLabels[option]; }, renderOption: function (props, option) { return (_createElement("li", __assign({}, props, { key: option }), unitSizeLabels[option])); }, value: getValues().spaces[index].property_size_unit, onChange: function (e, newValue) {
                                                    setValueWithValidation("spaces.".concat(index, ".property_size_unit"), newValue);
                                                    setUnit(newValue);
                                                    handleTracking({
                                                        target: {
                                                            name: "property_size_unit",
                                                            value: newValue,
                                                        },
                                                    });
                                                }, renderInput: function (params) { return (_jsx(TextField, __assign({ variant: "standard", "data-qa": "space-unit", className: "scheduler-inputs" }, params, { label: t("CAPTURE_SERVICES.ORDER.SPACES.spaceSizeUnit"), inputProps: __assign(__assign({}, params.inputProps), { autoComplete: "new-password" }) }))); } }));
                                        }, rules: {
                                            required: true,
                                        } })] }))] }), space.id)); }), spaces.length > 1 &&
                        _jsx(PropertyExtra, { totalSpaces: getValues().spaces.length, spacesSize: totalSize, sizeUnit: getValues().spaces[0].property_size_unit }), error && errorData &&
                        _jsxs("div", __assign({ className: "error-size" }, { children: [_jsx(ErrorOutline, { style: { color: "#f44336" } }), _jsx("p", __assign({ "data-qa": "space-size-error" }, { children: tReact("CAPTURE_SERVICES.SCHEDULER.ADDRESS.ERRORS.EXCEEDED_MAX_PROPERTY_SIZE_NEW", null, { size: errorData.limit, sizeUnit: errorData.errorUnit, url: 'https://matterport.com/contact-us' }) }))] })), error && !errorData &&
                        _jsxs("div", __assign({ className: "error-size" }, { children: [_jsx(ErrorOutline, { style: { color: "#f44336" } }), _jsx("p", __assign({ "data-qa": "space-size-error" }, { children: error }))] })), _jsxs("div", __assign({ className: "space-area-buttons" }, { children: [_jsx("div", { children: _jsx(Button, { "data-qa": "space-add-space-button", dark: true, onClick: addSpace, label: "+ ".concat(t("CAPTURE_SERVICES.ORDER.SPACES.LIST.ACTIONS.addNew")), disabled: !!error, type: "button", htmlId: "space-add-space-button", buttonType: "secondary" }) }), _jsxs("div", __assign({ className: "space-area-buttons-flex" }, { children: [_jsx(Button, { className: "margin-right-10", dark: true, onClick: resetOnBack, "data-qa": "space-return-button", type: "button", label: t("CAPTURE_SERVICES.SCHEDULER.back"), htmlId: "space-return-button", buttonType: "secondary" }), _jsx(Button, { className: "button-new", dark: true, "data-qa": "space-next-button", disabled: !formState.isValid || !!error || disabledNext, type: "submit", label: t("CAPTURE_SERVICES.SCHEDULER.next"), htmlId: "space-next-button", buttonType: "primary" })] }))] }))] })), freeUserCheck &&
                (_jsxs("div", __assign({ className: "mp-capture-svc-freeuser-message" }, { children: [_jsx(EstimatedPrice, {}), _jsx("p", { "data-qa": "upgrade-notification", className: "mp-capture-svc-upgrade-message", dangerouslySetInnerHTML: {
                                __html: successMessage
                            } }), _jsx(SchedulerCTA, { handleOnClick: inputReset })] })))] }));
}
